export default __webpack_public_path__ + "static/media/invest.93bf4dbb.png";